<div class="row">
    <main class="col-12 col-md-9" role="main">
        <div class="skv-box skv-box--compact">
            <router-outlet></router-outlet>
            <div class="parent">
                <div class="table-row">
                    <div *ngIf="hasNext" class="child-left">
                        <button class="btn btn--primary" type="button" (click)="toNext()"
                            [disabled]="!navigationEnabled">Nästa</button>
                    </div>
                    <div *ngIf="isLastPage" class="child-left">
                        <ng-container *ngIf="authorized then submitButton; else closeButton"></ng-container>
                        <ng-template #submitButton>
                            <button *ngIf="!sending; else loading" class="btn btn--primary" type="submit"
                                [disabled]="!formValid" (click)="onSubmit()">Skicka in</button>
                        </ng-template>
                        <ng-template #closeButton>
                            <button class="btn btn--primary" type="button" data-test-id="close-button"
                                (click)="closeApplication()">Avsluta</button>
                        </ng-template>
                    </div>
                    <div *ngIf="hasPrevious" class="child-right">
                        <button class="btn btn--secondary" type="button" (click)="toPrevious()"
                            [disabled]="!navigationEnabled">Föregående</button>
                    </div>
                </div>
            </div>
        </div>
        <app-banner *ngIf="error" type="error">
            <h3>Kunde inte skicka in din ansökan. Vänligen försök igen. Kontakta support om problemet kvarstår.</h3>
        </app-banner>
    </main>
    <div class="col-12 col-md-3">
        <div class="skv-box skv-box--compact skv-box--no-padding">
            <div style="padding: 10px;">
                <app-navigation-bar *ngIf="pathValid" [fade]="isStartPage" [elements]="pageFlow" [currentIndex]="path">
                </app-navigation-bar>
            </div>
        </div>
    </div>
</div>

<ng-template #loading>
    <mat-spinner diameter="40"></mat-spinner>
</ng-template>